import styled from 'styled-components'

export const VerifyWrapper = styled.div`
  & button[type='submit'] {
    margin-top: 15px;
  }
`
